/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";

import { nmibleInstanceV3 } from "../../mutator/axios-instance-v3";

import type {
  ContactCreate,
  ContactRead,
  ContactUpdate,
  DataResponseListContactRead,
  ErrorResponse,
  HTTPValidationError,
} from "../../model";
import type { ErrorType, BodyType } from "../../mutator/axios-instance-v3";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Get all contacts
 * @summary List Contacts
 */
export const listContactsContactsGet = (
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<DataResponseListContactRead>(
    { url: `/contacts`, method: "GET", signal },
    options
  );
};

export const getListContactsContactsGetQueryKey = () => {
  return [`/contacts`] as const;
};

export const getListContactsContactsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listContactsContactsGet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listContactsContactsGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListContactsContactsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listContactsContactsGet>>
  > = ({ signal }) => listContactsContactsGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listContactsContactsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListContactsContactsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listContactsContactsGet>>
>;
export type ListContactsContactsGetQueryError = ErrorType<unknown>;

export function useListContactsContactsGet<
  TData = Awaited<ReturnType<typeof listContactsContactsGet>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listContactsContactsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listContactsContactsGet>>,
          TError,
          Awaited<ReturnType<typeof listContactsContactsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListContactsContactsGet<
  TData = Awaited<ReturnType<typeof listContactsContactsGet>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listContactsContactsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listContactsContactsGet>>,
          TError,
          Awaited<ReturnType<typeof listContactsContactsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListContactsContactsGet<
  TData = Awaited<ReturnType<typeof listContactsContactsGet>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listContactsContactsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Contacts
 */

export function useListContactsContactsGet<
  TData = Awaited<ReturnType<typeof listContactsContactsGet>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listContactsContactsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListContactsContactsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Create a new contact
 * @summary Create Contact
 */
export const createContactContactsPost = (
  contactCreate: BodyType<ContactCreate>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<ContactRead>(
    {
      url: `/contacts`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: contactCreate,
      signal,
    },
    options
  );
};

export const getCreateContactContactsPostMutationKey = () =>
  ["createContactContactsPost"] as const;

export const getCreateContactContactsPostMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createContactContactsPost>>,
    TError,
    CreateContactContactsPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createContactContactsPost>>,
  TError,
  CreateContactContactsPostMutationVariables,
  TContext
> => {
  const mutationKey = getCreateContactContactsPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createContactContactsPost>>,
    CreateContactContactsPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createContactContactsPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateContactContactsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createContactContactsPost>>
>;
export type CreateContactContactsPostMutationBody = BodyType<ContactCreate>;
export type CreateContactContactsPostMutationError = ErrorType<
  ErrorResponse | HTTPValidationError
>;
export interface CreateContactContactsPostMutationVariables {
  data: BodyType<ContactCreate>;
}

/**
 * @summary Create Contact
 */
export const useCreateContactContactsPost = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createContactContactsPost>>,
      TError,
      CreateContactContactsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createContactContactsPost>>,
  TError,
  CreateContactContactsPostMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateContactContactsPostMutationOptions(options),
    queryClient
  );
};
/**
 * Get ALL contacts for participant using hierarchy: site > country > universal.
 *
 *     Workflow:
 *     - If unauthenticated: return ALL contacts
 *     - If authonticated + site_id available: return site-level contacts (site_id match) + country-level + universal
 *     - If authonticated + country_code available (but no site_id): return country-level + universal
 *
 *     Returns ALL matching contacts, ordered by priority (site first, then country, then universal).
 * @summary Get contacts for participant
 */
export const getContactsForParticipantContactsParticipantGet = (
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<DataResponseListContactRead>(
    { url: `/contacts/participant`, method: "GET", signal },
    options
  );
};

export const getGetContactsForParticipantContactsParticipantGetQueryKey =
  () => {
    return [`/contacts/participant`] as const;
  };

export const getGetContactsForParticipantContactsParticipantGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getContactsForParticipantContactsParticipantGet>
  >,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getContactsForParticipantContactsParticipantGet>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetContactsForParticipantContactsParticipantGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getContactsForParticipantContactsParticipantGet>>
  > = ({ signal }) =>
    getContactsForParticipantContactsParticipantGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getContactsForParticipantContactsParticipantGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetContactsForParticipantContactsParticipantGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getContactsForParticipantContactsParticipantGet>>
  >;
export type GetContactsForParticipantContactsParticipantGetQueryError =
  ErrorType<unknown>;

export function useGetContactsForParticipantContactsParticipantGet<
  TData = Awaited<
    ReturnType<typeof getContactsForParticipantContactsParticipantGet>
  >,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getContactsForParticipantContactsParticipantGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getContactsForParticipantContactsParticipantGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getContactsForParticipantContactsParticipantGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContactsForParticipantContactsParticipantGet<
  TData = Awaited<
    ReturnType<typeof getContactsForParticipantContactsParticipantGet>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getContactsForParticipantContactsParticipantGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getContactsForParticipantContactsParticipantGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getContactsForParticipantContactsParticipantGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContactsForParticipantContactsParticipantGet<
  TData = Awaited<
    ReturnType<typeof getContactsForParticipantContactsParticipantGet>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getContactsForParticipantContactsParticipantGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get contacts for participant
 */

export function useGetContactsForParticipantContactsParticipantGet<
  TData = Awaited<
    ReturnType<typeof getContactsForParticipantContactsParticipantGet>
  >,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getContactsForParticipantContactsParticipantGet>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetContactsForParticipantContactsParticipantGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Update an existing contact
 * @summary Update Contact
 */
export const updateContactContactsContactIdPut = (
  contactId: string,
  contactUpdate: BodyType<ContactUpdate>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<ContactRead>(
    {
      url: `/contacts/${contactId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: contactUpdate,
      signal,
    },
    options
  );
};

export const getUpdateContactContactsContactIdPutMutationKey = () =>
  ["updateContactContactsContactIdPut"] as const;

export const getUpdateContactContactsContactIdPutMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateContactContactsContactIdPut>>,
    TError,
    UpdateContactContactsContactIdPutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateContactContactsContactIdPut>>,
  TError,
  UpdateContactContactsContactIdPutMutationVariables,
  TContext
> => {
  const mutationKey = getUpdateContactContactsContactIdPutMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateContactContactsContactIdPut>>,
    UpdateContactContactsContactIdPutMutationVariables
  > = (props) => {
    const { contactId, data } = props ?? {};

    return updateContactContactsContactIdPut(contactId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateContactContactsContactIdPutMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateContactContactsContactIdPut>>
>;
export type UpdateContactContactsContactIdPutMutationBody =
  BodyType<ContactUpdate>;
export type UpdateContactContactsContactIdPutMutationError = ErrorType<
  ErrorResponse | HTTPValidationError
>;
export interface UpdateContactContactsContactIdPutMutationVariables {
  contactId: string;
  data: BodyType<ContactUpdate>;
}

/**
 * @summary Update Contact
 */
export const useUpdateContactContactsContactIdPut = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateContactContactsContactIdPut>>,
      TError,
      UpdateContactContactsContactIdPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateContactContactsContactIdPut>>,
  TError,
  UpdateContactContactsContactIdPutMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdateContactContactsContactIdPutMutationOptions(options),
    queryClient
  );
};
/**
 * Delete a contact (soft delete)
 * @summary Delete Contact
 */
export const deleteContactContactsContactIdDelete = (
  contactId: string,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<void>(
    { url: `/contacts/${contactId}`, method: "DELETE", signal },
    options
  );
};

export const getDeleteContactContactsContactIdDeleteMutationKey = () =>
  ["deleteContactContactsContactIdDelete"] as const;

export const getDeleteContactContactsContactIdDeleteMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteContactContactsContactIdDelete>>,
    TError,
    DeleteContactContactsContactIdDeleteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteContactContactsContactIdDelete>>,
  TError,
  DeleteContactContactsContactIdDeleteMutationVariables,
  TContext
> => {
  const mutationKey = getDeleteContactContactsContactIdDeleteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteContactContactsContactIdDelete>>,
    DeleteContactContactsContactIdDeleteMutationVariables
  > = (props) => {
    const { contactId } = props ?? {};

    return deleteContactContactsContactIdDelete(contactId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteContactContactsContactIdDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteContactContactsContactIdDelete>>
>;

export type DeleteContactContactsContactIdDeleteMutationError = ErrorType<
  ErrorResponse | HTTPValidationError
>;
export interface DeleteContactContactsContactIdDeleteMutationVariables {
  contactId: string;
}

/**
 * @summary Delete Contact
 */
export const useDeleteContactContactsContactIdDelete = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteContactContactsContactIdDelete>>,
      TError,
      DeleteContactContactsContactIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteContactContactsContactIdDelete>>,
  TError,
  DeleteContactContactsContactIdDeleteMutationVariables,
  TContext
> => {
  return useMutation(
    getDeleteContactContactsContactIdDeleteMutationOptions(options),
    queryClient
  );
};
